import { IDmKhoiNganh } from "../../../model/respone/category/IDmKhoiNganh";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmKhoiNganhActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmKhoiNganh[],
  LOAD_ERRR: "",
};
export const eDmKhoiNganhActionIds = generateActionTypeIds(
  eDmKhoiNganhActionsObj,
  "KHOI_NGANH"
);
export type IDmKhoiNganhActionTypes = IGenericActionType<
  typeof eDmKhoiNganhActionsObj,
  "KHOI_NGANH"
>;
